import { render, staticRenderFns } from "./officialConfirm.vue?vue&type=template&id=b9f2d29e&scoped=true"
import script from "./officialConfirm.vue?vue&type=script&lang=js"
export * from "./officialConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f2d29e",
  null
  
)

export default component.exports